import React from 'react';
import { LogTab } from '../Hub/Kitchen';

/**
 * FoodLogWidget - Food logging widget
 * 
 * Thin wrapper around LogTab.
 * State is managed by useFoodLog hook in App.js.
 * 
 * Receives data and handlers from props (passed through from App.js)
 */
export default function FoodLogWidget({
  // Data from useFoodLog
  selectedDate,
  entries = [],
  entriesByMeal = {},
  totals = {},
  isLoading = false,
  isSaving = false,
  isToday = true,
  trackedMacros = ['protein', 'carbs', 'fat'],
  dailyTargets = {},
  availableMacros = [],
  // Handlers
  onAddEntry,
  onDeleteEntry,
  onDateChange,
  onGoToToday,
  onAddTrackedMacro,
  onRemoveTrackedMacro,
  // UI
  showToast
}) {
  return (
    <LogTab
      selectedDate={selectedDate}
      entries={entries}
      entriesByMeal={entriesByMeal}
      totals={totals}
      isLoading={isLoading}
      isSaving={isSaving}
      isToday={isToday}
      trackedMacros={trackedMacros}
      dailyTargets={dailyTargets}
      availableMacros={availableMacros}
      onAddEntry={onAddEntry}
      onDeleteEntry={onDeleteEntry}
      onDateChange={onDateChange}
      onGoToToday={onGoToToday}
      onAddTrackedMacro={onAddTrackedMacro}
      onRemoveTrackedMacro={onRemoveTrackedMacro}
      showToast={showToast}
    />
  );
}
